"use strict";
/**
 * Domain helpers for the Personas admin view (kept separate from the
 * generic `personas-utils.ts` clone/equality helpers).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueUseCaseCount = void 0;
/**
 * Returns the number of distinct use cases that reference at least one
 * persona in the given group. Used by the group card chip to answer
 * "in how many use cases is this persona group present?" without
 * double-counting use cases that target multiple personas in the group.
 */
exports.getUniqueUseCaseCount = function (category) {
    var ids = {};
    category.properties.forEach(function (property) {
        property.useCases.forEach(function (useCase) {
            ids[useCase.id] = true;
        });
    });
    return Object.keys(ids).length;
};
